import { isServerSide } from '../../../../utilities/user-agent.mjs';
import { SizeValue, AnimationState } from './types.mjs';

const SIZES = Object.values(SizeValue);
const MAX_SIZES_INDEX = SIZES.length - 1;
function getNextSize(currentSize) {
  const currentSizeIndex = SIZES.indexOf(currentSize);
  const sizesIndexOffset = currentSizeIndex === MAX_SIZES_INDEX ? currentSizeIndex - 1 : currentSizeIndex + 1;
  return SIZES[sizesIndexOffset];
}
function getBottomPosition({
  top,
  height
}) {
  const htmlElement = isServerSide() ? undefined : document.documentElement;
  const htmlHeight = htmlElement && htmlElement.clientHeight;
  return htmlHeight ? htmlHeight - (top + height) : 0;
}
function getDimensions(node) {
  return node ? node.getBoundingClientRect() : null;
}
function getHeight(node) {
  return node ? node.offsetHeight : null;
}
function getWrapperHeight({
  wrapper,
  children,
  cloneTarget
}) {
  return cloneTarget + (wrapper - children);
}
function getWrapperStyles(height) {
  return height != null ? {
    height
  } : undefined;
}
function getComboStyles({
  comboDimensions,
  wrapperHeight
}) {
  if (!comboDimensions || wrapperHeight == null) {
    return undefined;
  }
  const {
    top,
    left,
    width
  } = comboDimensions;
  return {
    top,
    left,
    bottom: getBottomPosition({
      top,
      height: wrapperHeight
    }),
    width
  };
}
function isInitialState({
  size,
  animation
}) {
  return size === SizeValue.Default && animation === AnimationState.Idle;
}
function isExpandingFromDefault({
  previousSize,
  nextSize
}) {
  return previousSize === SizeValue.Default && nextSize === SizeValue.Expanded;
}
function isExpandingFromExpanded({
  previousSize,
  nextSize
}) {
  return previousSize === SizeValue.Expanded && nextSize === SizeValue.Fullscreen;
}
function isShrinkingToDefault(portalCriteria, beforeInclusive = false) {
  const {
    size,
    animation
  } = portalCriteria;
  const animationCondition = beforeInclusive ? animation === AnimationState.Shrinking || animation === AnimationState.BeforeShrinking : animation === AnimationState.Shrinking;
  return size === SizeValue.Default && animationCondition;
}
function requiresDimensions({
  size,
  animation
}) {
  const expanding = size === SizeValue.Expanded && animation === AnimationState.BeforeExpanding;
  const shrinking = size === SizeValue.Default && (animation === AnimationState.BeforeShrinking || animation === AnimationState.Shrinking);
  return expanding || shrinking;
}
function requiresPortal({
  size,
  animation
}) {
  return size !== SizeValue.Default || isShrinkingToDefault({
    size,
    animation
  }, true);
}

export { getBottomPosition, getComboStyles, getDimensions, getHeight, getNextSize, getWrapperHeight, getWrapperStyles, isExpandingFromDefault, isExpandingFromExpanded, isInitialState, isShrinkingToDefault, requiresDimensions, requiresPortal };
